import { translate } from '@utils/i18n';
import { IKeyValueType } from '@components/v2/KeyValueList';
const namespace = 'features.customer_portal.deficiencies.drawer';
export function getGeneralInfo(deficiency) {
    var _a, _b, _c, _d;
    return [
        (deficiency.question || deficiency.displayName) && deficiency.answer
            ? {
                key: translate('fields.question', { namespace }),
                value: (_a = (deficiency.question || deficiency.displayName)) !== null && _a !== void 0 ? _a : translate('no_question_available', { namespace }),
                type: IKeyValueType.text
            }
            : undefined,
        deficiency.answer
            ? {
                key: translate('fields.answer', { namespace }),
                value: (_b = deficiency.answer) !== null && _b !== void 0 ? _b : translate('no_answer_available', { namespace }),
                type: IKeyValueType.text
            }
            : undefined,
        {
            key: translate('fields.date_opened', { namespace }),
            value: (_c = deficiency.dateOpened) !== null && _c !== void 0 ? _c : translate('not_available', { namespace }),
            type: IKeyValueType.text
        },
        deficiency.isResolved
            ? {
                key: translate('fields.date_resolved', { namespace }),
                value: (_d = deficiency.dateResolved) !== null && _d !== void 0 ? _d : translate('not_available', { namespace }),
                type: IKeyValueType.text
            }
            : undefined
    ].filter(Boolean);
}
export function getAssetsInfo(deficiency) {
    return Object.entries(deficiency.assetDetails).map(([key, value]) => ({
        key,
        value: value !== null && value !== void 0 ? value : translate('n_a', { namespace: 'generic' }),
        type: IKeyValueType.text
    }));
}
